import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const NavVisibilityContext = createContext();

export const useNavVisibility = () => {
  const context = useContext(NavVisibilityContext);
  if (!context) {
    throw new Error('useNavVisibility must be used within NavVisibilityProvider');
  }
  return context;
};

export const NavVisibilityProvider = ({ children }) => {
  const [isNavVisible, setIsNavVisible] = useState(true);

  const hideNav = useCallback(() => {
    setIsNavVisible(prev => prev === false ? prev : false);
  }, []);
  
  const showNav = useCallback(() => {
    setIsNavVisible(prev => prev === true ? prev : true);
  }, []);

  // Memoriza o value para evitar re-renders desnecessários
  const value = useMemo(() => ({ 
    isNavVisible, 
    hideNav, 
    showNav 
  }), [isNavVisible, hideNav, showNav]);

  return (
    <NavVisibilityContext.Provider value={value}>
      {children}
    </NavVisibilityContext.Provider>
  );
};
